import * as React from 'react';
import ErrorLayout from './ErrorLayout';
import SVGIllustrationGeneralError from 'components/svg/IllustrationGeneralError';
import { translate } from 'utils/translateUtil';
import ParagraphSecondary from 'components/ui/Paragraphs/ParagraphSecondary';
import { Link } from 'components/text';

const Internal = () => (
    <ErrorLayout
        header={<SVGIllustrationGeneralError />}
        title={translate('globals.errorPage.internal.title')}
        description={
            <>
                <ParagraphSecondary>
                    {translate(
                        'globals.errorPage.internal.descriptionPartialOne'
                    )}
                    <b>{translate('globals.hotline')}</b>
                    {translate(
                        'globals.errorPage.internal.descriptionPartialTwo'
                    )}
                </ParagraphSecondary>
                <Link
                    internal={false}
                    href={`mailto:${translate('globals.supportEmail')}`}
                >
                    {translate('globals.supportEmail')}
                </Link>
            </>
        }
    />
);

export default Internal;
